export type Vacancy = {
  id: string;
  title: string;
  description: string;
  responsabilities: string[];
  requirements: string[];
  valuableAssets: string[];
};

export const vacancies: Vacancy[] = [
  
//   {
//     id: 'id-8',
//     title: 'Head of marketing - Inbound Saas B2B',
//     description:
//       'As an Innovative Head of Marketing you will drive and elevate our marketing efforts. \
// This key role will boost brand visibility and craft impactful strategies that resonate with our target audiences in the AI and simulation space.\
// You will lead the development and execution of strategic marketing initiatives aimed at driving customer acquisition, \
// brand growth, and engagement. You will define AILiveSim’s core value propositions, create compelling content for key stakeholders, \
// and collaborate with cross-functional teams, including sales and leadership, to align our marketing efforts with broader business objectives. \
// This role also involves spearheading multi-channel campaigns and enhancing thought leadership in the AI and simulation sectors.\
//       ',
//       responsabilities:[
//         'Develop and lead the overall marketing strategy, including positioning, messaging, and go-to-market plans'
//       , 'Collaborate with Sales, Product, and Leadership teams to align marketing strategies with business objectives and growth targets'
//       , 'Create and execute demand generation campaigns aimed at driving customer acquisition, engagement, and retention'
//       , 'Design and implement tactics to promote our brand and drive qualified traffic to our channels'
//       , 'Drive thought leadership initiatives, including whitepapers, industry reports and any relevant speaking engagements'
//       , 'Manage the marketing budget, allocating resources effectively to maximise ROI'
//       ,'Plan and implement compelling marketing material and presentations in collaboration with the team'
//       ,'Create, run and optimize multi-channel marketing campaigns, tracking and reporting their effectiveness.'
//       ,'Ensure consistent branding across different platforms'
//       ,'Manage AILiveSim\'s social media profiles and advertising efforts'
//       ],
//       requirements: [
//       'Proven experience & successful track record of driving successful marketing strategies within a technology or Saas environment'
//       ,'In-depth understanding of SaaS business models, target markets, and customer personas'
//       ,'Strategic thinker with the ability to translate vision into actionable marketing plans'
//       ,'Strong user acquisition skills and grasp of SEO principles'
//       ,'Up-to-date with the latest trends and best practices in SaaS marketing'
//       ,'Excellent written and verbal communication skills in English'
//       ,'Proactive and able to thrive in a fast-paced, collaborative environment'
//       ],
//       valuableAssets: [
//         'Proficiency in digital marketing, demand generation, and marketing automation platforms'
//       , 'Technical understanding of Artificial Intelligence and/or simulation'
//       ],
//   },
//   {
//     id: 'id-9',
//     title: 'Head of Inbound Sales - Saas B2B',
//     description:
//       'We are seeking an experienced and strategic Head of Sales to lead and streamline our sales efforts. This role will be crucial in driving growth, enhancing the sales process, and building a high-performing team focused on delivering scalable and reproducible sales outcomes.\
// \
// As the Head of Sales, you will be responsible for developing and executing an inbound sales strategy that fosters repeatable success. In this role, you will be responsible for optimizing the sales process from initial contact through to conversion, ensuring a seamless customer journey. You will also lead initiatives to streamline team operations, and ensure they have the right resources and strategies to consistently meet targets. Additionally, you will collaborate across departments to align sales with business goals and provide reporting, analysis, and forecasting.\
//       ',
//       responsabilities:[
//         'Develop and execute sales strategy for inbound and reproducible sales models'
//       , 'Streamline the sales process from contact to conversion'
//       , 'Create and implement plans, action and communication roadmap for any process changes'
//       , 'Prepare standardized sales material for different engagements'
//       , 'Provide recommendations for product and platform development to support strategic goals'
//       , 'Technical Understand Artificial Intelligence and/or simulation'
//       , 'Lead and manage a reproducible sales team'
//       , 'Conduct regular reporting, analysis, and forecasting to track sales performance'
//       ],
//       requirements: [
//       'Proven experience in B2B sales, SaaS, value-based selling, or consultative selling'
//       ,'Strong technical understanding of AI, simulation, or related technologies'
//       ,'Excellent communication and interpersonal skills'
//       ,'Ability to thrive in a fast-paced, results-driven environment'
//       ,'Willingness to travel when necessary'
//       ],
//       valuableAssets: [
//         'Experience in a sales at leadership position'
//       , 'Proven track record of developing and executing successful sales strategies across different geographies and industries'
//       , 'Experience in marketing, marcom, or marketing strategy'
//       , 'Creative, energetic, and able to inspire others'
//       , 'Experience with CRM systems and other sales tools'
//       ],
//   },
  // {
  //   id: 'id-9',
  //   title: 'Machine Learning Engineer',
  //   description:
  //     'On a mission to remove the human from the training process, we\'re currently on the lookout for several talented and driven Machine Learning Engineers to join our Machine Learning team, \
  //     that brings AI features to our product. Our team is developing tools to train AI solutions, using AI to enhance the efficiency and quality of the scenarios we create. \
  //     If you\'re passionate about building neural networks and capable of designing your own models, strategies, and datasets, we\'d love to hear from you.\
  //     ',
  //     responsabilities:[
  //       'Build, deploy and maintain machine learning models, ensuring performance and quality outcome.'
  //     , 'Follow latest "State of the Art" techniques, and apply them to our current solutions.'
  //     , 'Design, collect, curate and maintain datasets of real or synthetic data.'
  //     , 'Design and implement ML training pipelines and testing suites.'
  //     , 'Collaborates with the product development team to bring AI features to our product.'
  //     ],
  //     requirements: [
  //     'Hands-on experience with AI projects and developing AI applications.'
  //     ,'Proficiency in Python and relevant frameworks such as PyTorch, TensorFlow, or similar.'
  //     ,'Ability to design, write, test, and debug code, implement software applications, document design decisions, and develop modular software components.'
  //     ,'Ability to work in fast iterations, with minimal documentation, solving complex problems with rapid prototyping and getting things done attitude.'
  //     ,'Do not reinvent the wheel, reuse and integrate solutions that are already available.'
  //     ,'Strong background in developing algorithms and implementing computational methods.'
  //     ,'Wants to participate in the developing the best tool to train and test AI. '
  //     ],
  //     valuableAssets: [
  //       'Experience developing or using GenAI, or Large Multimodal models.'
  //     , 'Experience in machine vision or perception for robotics or automotive applications.'
  //     , 'Good understanding of 3D math for example for sensor fusion, Slam, projections, as well as Statistical modeling.'
  //     , 'Professional experience with Cloud based AI, and edge AI solutions at scale.'
  //     , 'Strong background programming various applications with various languages, C,/C++, Python and more.'
  //     , 'Ability to see the big picture, and to present architecture decisions.'
  //     , 'Bachelor\'s or Master\'s degree in Computer Science, Engineering, Mathematics, or a related field.'
  //     ],
  // },
  {
    id: 'id-1',
    title: 'Senior Games Programmer / Unreal Engine',
    description:
      'Your responsibility is to design and implement parts of our system, inspire & lead other programmers and to guide the content team. \
       As a senior developer, you have high freedom and high responsibility. You are not afraid of tackling problems in any area of the solution,\
       you have a vision on how things should be done, but you’re always ready to learn new techniques.',
       responsabilities:[
         'Lead the design and implementation of complex software systems for serious applications, with a focus on simulation technology'
       , 'Collaborate with cross-functional teams, including engineers, artists, and customers, to deliver high-quality solutions'
       , 'Develop and maintain robust, scalable, and efficient code for real-time simulations'
       , 'Mentor and guide junior programmers, fostering a collaborative and innovative team environment'
       , 'Stay updated on industry trends and emerging technologies to enhance AILiveSim\'s competitive edge'
       , 'Contribute to the architecture and design of simulations that impact AI training and development'],
       requirements: [
       'Proven experience as a Senior Programmer in a relevant industry or domain'
       , 'Expertise in software development, with games, serious applications or simulations'
       , 'Proficiency in one or more programming languages, with a preference for C++'
       , 'Strong problem-solving skills and the ability to lead and mentor a team'
       , 'Experience with Unreal Engine or similar game development engines'
     ],
     valuableAssets: [
       'game development or experience in a 3D game'
       ,'Familiarity with AI and machine learning technologies' 
       ,'At ease with test driven development' 
       ,'Familiar with AI and neural networks training'
       ,'Played with robotics and embedded programming' 
     ],
  },
  
  {
    id: 'id-5',
    title: 'Programmer, Simulation / Unreal Engine',
    description:
      'As part of our programming team you will take part in the development and maintenance of various featuers of our software.\
      You are passionate about game technology, XR or simulation, and are looking to sharpen your skills with industry application. \
      You might not have tons of experience, but you have worked on personal projects and have a strong will to learn and to succeed.\
      We work in an agile way and you will have the ability to impact on your work.\
      ',
      responsabilities:[
        'Design and implement parts of our software, new features, and to guide the content team'
      , 'Maintain and improve our solution'
      , 'Create and improve examples and documentation'
      ],
      requirements: [
      'Experience with programming game play, graphics, animations or other subsystems or tools for game or simulation'
      ,'Know about games or real time 3D simulation'
      ,'Familiar with unreal engine'
      ,'Familiar with C++ and python'
      ],
      valuableAssets: [
        'Game development, experience in a 3D game'
      , 'Computer graphics'
      , 'Test driven development'
      , 'Embedded robotics software'
      ],
  },
  // {
  //   id: 'id-2',
  //   title: 'Technical Artist',
  //   description:
  //     'AILiveSim creates procedural environments that look very realistic while supporting a large number of variations. You will be creating stunning environments and fill them with realism near real life.',
  //   requirements: [
  //     'Strong 3D art production skills (3dsmax/maya, Zbrush, Houdini, Substance Painter etc..)'
  //     ,'Knowledge and experience of processes, pipelines and best practices of game art production'
  //     ,'Be able to work as part of a team and independently as you are working from home'
  //     ,'Making stunning procedural materials'
  //     ,'Knowledge of optimizing assets and environments'
      
  //   ],
  //   valuableAssets: [
  //     'Experience in games or simulation projects'
  //     ,'Familiar with Unreal Engine, Blueprints, scripting or programming'
  //     ,'Knowledge of VFX and lighting'
  //     ,'Experience with photogrammetry'
  //     ,'Knowledge of Substance Designer'
      
  //   ],
  // },
  // {
  //   id: 'id-3',
  //   title: 'DevOps',
  //   description:
  //     'AILiveSim provides large-scale simulation on the cloud. We are seeking a talented full-stack engineer to further develop our high performance and scalable implementation for our simulation platform and services and to integrate third party services. You will have the ability to shape and influence our product and offering.',
  //   requirements: [
  //     'Amazon Web Services, in particular AWS Lambda, DynamoDB',
  //     'Serverless application framework',
  //     'Python',
  //     'Front End application stack HTML/CSS/React js',
  //   ],
  //   valuableAssets: [
  //     'Experience with large scale AI applications',
  //     'Experience in game development or game companies',
  //     'Entrepreneur minded, worked in startup before',
  //   ],
  // },
  // {
  //   id: 'id-4',
  //   title: 'FullStack Engineer',
  //   description:
  //     'AILiveSim provides large-scale simulation on the cloud. We are seeking a talented full-stack engineer to further develop our high performance and scalable implementation for our simulation platform and services and to integrate third party services. You will have the ability to shape and influence our product and offering.',
  //   requirements: [
  //     'Amazon Web Services, in particular AWS Lambda, DynamoDB',
  //     'Serverless application framework',
  //     'Python',
  //     'Front End application stack HTML/CSS/React js',
  //   ],
  //   valuableAssets: [
  //     'Experience with large scale AI applications',
  //     'Experience in game development or game companies',
  //     'Entrepreneur minded, worked in startup before',
  //   ],
  // },

  {
    id: 'id-2',
    title: 'Sensor Simulation Engineer',
    description:
        'We are seeking several talented and motivated Sensor Simulation Programmer to join our development team at AILiveSim.\
        As a key player, you will be responsible for developing advanced sensor simulations, with a focus on LiDAR, radar, sonars, etc.. using Unreal Engine. \
        \
        This is an exciting opportunity to contribute to groundbreaking projects at the intersection of simulation and artificial intelligence.\
        ',
      responsabilities:[
          'Develop and implement realistic sensor simulations within Unreal Engine'
        , 'Collaborate with cross-functional teams to integrate sensor simulations into our procedural environments'
        , 'Optimize and fine-tune sensor simulations for real-time performance'
        , 'Stay abreast of the latest advancements in sensor technologies and simulation techniques'
        , 'Contribute to the design and development of innovative AI training scenarios'
        ],
      requirements: [
          'Proven experience in programming and simulation development, with a focus on sensors'
        , 'Proficiency in C++ and experience with Unreal Engine'
        , 'Strong understanding of at least one of the following sensor technologies: Radar FMCW, Radar UWB, Lidar, Sonar etc.'
        , 'Knowledge on the noise factors affecting the different sensors'
        , 'Ability to optimize and troubleshoot simulations for performance and accuracy'
        , 'Excellent problem-solving and communication skills'
      ],
    valuableAssets: [
          'game development, experience in a 3D game'
        , 'Previous experience with AI training simulations' 
        , 'Knowledge in development of perception algorithms in the world of ADAS/ autonomous driving with Radar and fused data' 
        , 'Experience with simulation technologies such as Unity, Unreal Engine, Gazebo, or MATLAB'
      ],
  },
  // {
  //   id: 'id-3',
  //   title: 'Animation Programmer',
  //   description:
  //     'AILiveSim is seeking a skilled and creative Animation Programmer to join our team. As an Animation Programmer, \
  //     you will play a crucial role in developing and implementing advanced animation systems for our simulations. \
  //     This is a unique opportunity to contribute to projects that integrate animation and artificial intelligence, \
  //     while creating realistic and dynamic training environments.\
  //     ',
  //     responsabilities:[
  //       'Develop and implement animation systems, character mechanics, and rigging for real-time simulations'
  //       , 'Collaborate with artists, designers, and fellow programmers to integrate animations seamlessly into immersive environments'
  //       , 'Optimize animation performance and troubleshoot issues to ensure smooth and realistic simulations'
  //       , 'Contribute to the design and scope of projects at the intersection of animation and artificial intelligence'
  //       , 'Develop, expand, maintain, and support an extensive runtime animation system, pipeline, and tools'
  //     ],
  //     requirements: [
  //       'Proven experience in animation programming, with a strong portfolio showcasing relevant project'
  //       ,'Proficiency in Unreal Engine, including experience with animation Blueprints and character animation'
  //       , 'Solid understanding of animation principles, rigging, and character mechanics'
  //       , 'Strong problem-solving skills and the ability to work collaboratively in a dynamic team environment'
  //       , 'Passion for innovation and a commitment to staying updated on industry trends'
  //     ],
  //     valuableAssets: [
  //       'Experience with motion capture technologies'
  //       ,'Knowledge of AI-driven animation techniques' 
  //       ,'Familiarity with virtual reality (VR) or augmented reality (AR) development' 
  //     ],
  // },
  // {
  //   id: 'id-4',
  //   title: 'Graphics programmer UE5 - shaders - VFX',
  //   description:
  //       'This is an opening for a graphics programmer to join our development team at AILiveSim.You will be responsible for developing advanced simulations using Unreal Engine. Your responsibilities will include all rendering based sensors, as well as improving the general visual quality and performance of our application. You will get to apply your knowledge and experience with various techniques to create very realistic and accurate simulations.\
  //       This is an exciting opportunity to contribute to groundbreaking projects at the intersection of simulation and artificial intelligence. \
  //       ',
  //     responsabilities:[
  //       'Develop and maintain all our rendering based sensors'
  //       , 'Improve the realism and performance of of our simulation,'
  //       , 'Work closely with technical artists and other programmers'
  //       ,  'Create sharers and vfx to obtain desired results'
  //       , 'Design, implement, test, debug, optimize various elements of our simulator'
  //     ],
  //     requirements: [
  //         '3 plus years of experience working as a game developer, graphics programmer, or closely related position'
  //       , 'Advanced expertise in C/C++'
  //       , 'Experience with performance profiling and optimization on the GPU and/or CPU'
  //     ],
  //     valuableAssets: [
  //       'Graphics programming knowledge, including full understanding of the graphics pipeline and experience with Unreal, DirectX 12 / Vulkan'
  //       ,' Proficiency in shader programming, especially in the context of thermal imaging. This includes creating custom shaders to simulate thermal effects' 
  //       ,'Experience in AAA games development' 
  //       ,'Prior experience with LWIR and SWIR thermal imaging technologies'
  //       ,'Knowledge of the physics behind thermal imaging and the ability to translate this knowledge into effective software solutions'
  //       ,'Ability to optimize code and implement performance improvements to ensure smooth real-time rendering of thermal imagery within the game engine'
  //       ,' Effective communication skills to collaborate with cross-functional teams, including artists, designers, and other engineers'
  //       ,'Previous experience in 3D graphics or vfx programming, preferably in Unreal engine'

  //     ],
  // },
  {
    id: 'id-6',
    title: 'Technical customer success engineer',
    description:
      ' As a Technical Customer Success Engineer, you will collaborate closely with customers, offering technical expertise and support for our simulation platform. \
        This is an engaging role, and you will be responsible for delivering excellent technical assistance through multiple channels, including phone, email, and live chat. \
        Additionally, you will partner with our Engineering and Product teams to address and resolve complex issues efficiently, ensuring smooth customer experience. \
        Serving as a bridge between internal teams and customers, gathering feedback and insights to help drive continuous improvements, is also essential.'
      ,
      responsabilities:[
         'Develop custom deliverables for customers, including Python scripts, simulation files, and datasets.'
        ,'Address customer support requests with prompt and effective solutions.'
        ,'Create and implement demos, examples, and tutorials to enhance customer understanding.'
        ,'Manage and update documentation and training materials.'
        ,'Deliver training sessions to customers, helping them maximise the platform\'s potential.'
        ,'Represent customer and user voice when contributing to decisions on new features and enhancements.'
      ],
      requirements: [
         'Solid knowledge and experience in at least one of the following areas: machine learning, robotics, ROS, or self-driving vehicles.'
        ,'Proficiency in Python programming.'
        ,'Strong communication skills, with the ability to collaborate effectively with both business and technology teams.'
        ,'A proactive attitude and a genuine passion for technology.'
      ],
      valuableAssets: [
        'Experience in game companies'
      , 'Experience in QA, implementation technical test, automated test systems'
      , 'Familiar with Unreal engine and C++'
      , 'Entrepreneur minded, worked in startup before'
      ],
  },
  // {
  //   id: 'id-10',
  //   title: 'Technical Sales Engineer',
  //   description:
  //     ' As a Technical Sales Engineer, you will collaborate closely with customers and build strong relationships with them, and ensure they continue to get the best value of our platform. \
  //       This role will be pivotal in identifying new opportunities, engaging diverse stakeholders, and contributing to the development of sales and marketing strategies. \
  //       The ideal candidate will leverage their expertise in autonomous vehicles, AI technologies, and B2B sales to deliver impactful, scalable outcomes.'
  //     ,
  //     responsabilities:[
  //        'Facilitate technical discussions with stakeholders, including engineers and senior management.'
  //       ,'Deliver product demonstrations and presentations to diverse audiences.'
  //       ,'Research, network, and engage in outreach to identify and develop new business opportunities.'
  //       ,'Proactively connect with prospects and leads via phone, email, and social media platforms.'
  //       ,'Conduct research to target potential customers and decision-makers effectively.'
  //       ,'Represent the company at industry events and conferences, promoting products and services.'
  //       ,'Maintain and update the CRM with accurate, up-to-date information.'
  //       ,'Support inbound sales efforts and contribute to the creation of customer support and marketing materials as required.'
  //     ],
  //     requirements: [
  //        'Comprehensive knowledge of autonomous vehicles and AI technologies.'
  //       ,'Strong belief in the importance of simulation and synthetic data for robust systems.'
  //       ,'Familiarity with B2B sales processes and strategies.'
  //       ,'Exceptional interpersonal and communication skills.'
  //       ,'Adaptability to thrive in a fast-paced, results-oriented environment.'
  //       ,'Based in the Helsinki area, with flexibility for remote work and occasional travel.'
  //     ],
  //     valuableAssets: [
  //       'Academic or professional background in autonomous vehicle technology.'
  //     , 'Programming experience with Python.'
  //     , 'Knowledge of machine vision and deep learning for awareness algorithms.'
  //     , 'Expertise in value-based or consultative sales approaches.'
  //     , 'Proficiency with CRM platforms and other sales tools.'
  //     ],
  // },
  {
    id: 'id-50',
    title: 'Producer',
    description:
      'We\'re currently looking for a Producer to help keep our technical teams aligned, projects on track, and workflows efficient. In this role you\'\
      ll work closely with the core technical, content and product teams  to ensure smooth communication, realistic planning, and effective execution. \
      This role is ideal for someone who understands game technology, AI, or simulation development and enjoys keeping highly skilled teams organized.\
      ',
      responsabilities:[
        'Facilitate communication between technical teams, ensuring alignment on priorities, blockers, and goals.'
      , 'Work closely with core tech, product and content teams to track progress and refine development roadmaps.'
      , 'Ensure smooth project execution by identifying risks, resolving dependencies, and keeping schedules realistic.'
      , 'Translate technical discussions into actionable plans while maintaining an understanding of how things are built.'
      , 'Adapt efficient, lightweight, and delivery focused processes that fit a startup environment.'
      ],
      requirements: [
      'Experience managing technical teams in game development, AI, or simulation-related fields.'
      ,'Strong understanding of game engines (e.g., Unreal Engine), software development processes, or AI workflows.'
      , 'Ability to communicate effectively with engineers, designers, and stakeholders.'
      , 'Experience with agile development and flexible planning approaches.'
      ,'Comfortable working in a fast-moving startup with evolving priorities.'
      ],
      valuableAssets: [
        'Background in technical production, project management, or engineering.'
      , 'Hands-on experience with Unreal Engine or similar technologies.'
      , 'Experience in Video games, AI, robotics, or synthetic data projects.'
      , ''
      , ''
      , ''
      ],
  },
  {
    id: 'id-11',
    title: 'UX Designer',
    description:
      'As a UX Designer, you will focus on creating impactful design solutions that enhance the accessibility and functionality of our products. \
       The role will involve understanding user needs, collaborating with our cross-functional teams to translate them into intuitive designs, \
       and ultimately ensuring a seamless experience for our simulation tools.\
      ',
      responsabilities:[
        'Design intuitive and visually appealing user interfaces for simulation and AI tools.'
        ,'Collaborate closely with developers and product teams to ensure feasibility and alignment.'
        ,'Maintain a consistent design system and UI/UX guidelines across products.'
        ,'Conduct user research, usability testing, and iterate based on feedback.'
        ,'Create wireframes, prototypes, and design documentation.'
      ],
      requirements: [
        ' Proven experience in UI/UX design, preferably in tech, gaming, or simulation.'
        ,' Proficiency with design tools such as Figma, Adobe XD, or Sketch.'
        ,' Familiarity with user research methodologies and usability testing.'
        ,' Understanding of game engines (e.g., Unreal Engine).'
      ],
      valuableAssets: [
        'Experience in game projects'
        ,'Experience with UE5'
      ],
  },

  // {
  //   id: 'id-12',
  //   title: 'UI Programmer (Unreal Engine) ',
  //   description:
  //     'As a UI Programmer, you will implement and optimize user interfaces within Unreal Engine to deliver \
  //      intuitive and immersive experiences. You’ll collaborate with the technical and content teams to translate \
  //      complex requirements into user-friendly solutions.\
  //     ',
  //     responsabilities:[
  //       'Develop and integrate UI systems using Unreal Engine’s UMG and Blueprints.'
  //       ,'Collaborate with UI/UX designers to implement responsive and engaging interfaces.'
  //       ,'Optimize UI performance for real-time applications.'
  //       ,'Debug and resolve UI-related issues to maintain high-quality standards.'
  //       ,'Stay updated with Unreal Engine advancements and industry best practices.'
  //     ],
  //     requirements: [
  //       'Strong experience in Unreal Engine, with a focus on UMG and Blueprints.'
  //       ,'Proficiency in C++ and/or Python scripting for UI development.'
  //       ,'Understanding of UI/UX principles and workflows.'
  //       ,'Experience in optimizing UI performance for real-time applications.'
  //     ],
  //     valuableAssets: [
  //       'Experience with UE5'
  //       ,'Familiarity with AI, simulation, or game technology is a plus.'
  //     ],
  // },

  // {
  //   id: 'id-9',
  //   title: '',
  //   description:
  //     '\
  //     ',
  //     responsabilities:[
  //       ''
  //     , ''
  //     ],
  //     requirements: [
  //     ''
  //     ,''
  //     ,''
  //     ],
  //     valuableAssets: [
  //       ''
  //     , ''
  //     , ''
  //     ],
  // },
];
